import shuffle from 'lodash/shuffle';
import { Component, OnInit } from '@angular/core';

import { CorporateNotificationType, EventTypeEnum } from '@sifca-monorepo/widget-generator';

import { MobileNotificationComponent } from './notification.component';
import { createStickerPools, getNotificationSticker, StickerPools } from '../../../helpers/notification-stickers';

@Component({
  template: '',
})
export class LoyalcraftNotificationComponent extends MobileNotificationComponent implements OnInit {
  private readonly happyEvents = [EventTypeEnum.REDEEM, EventTypeEnum.PUSH_AMOUNT, 'BET_WON', 'REWARD'];
  private stickerPools: StickerPools = createStickerPools();

  override ngOnInit(): void {
    this.stickerPools = createStickerPools({ shuffle });
    super.ngOnInit();
  }

  override getNotificationAvatar(notif: CorporateNotificationType): string | null {
    if (notif?.event === EventTypeEnum.ADHOC_NOTIFICATION) {
      const picture = notif?.action?.adhocNotification?.picture;
      if (picture?.baseUrl && picture?.path) {
        return `${picture.baseUrl}/${picture.path}`;
      }
    }

    return this.getNotificationPicture(notif);
  }

  getNotificationPicture(notif: CorporateNotificationType | null | undefined): string {
    return getNotificationSticker(notif, {
      pools: this.stickerPools,
      happyEvents: this.happyEvents,
      placeholder: 'assets/img/avatars/placeholder.png',
    });
  }
}
